(function ($) {
    $(document).ready(function(){
        var collection_slide = new Swiper(".collection-slide .swiper-container", {
            speed:1000,
            loop: false,
            autoplay: false,
            slidesPerView:4,
            spaceBetween: 22,           
            slidesOffsetAfter:0,
            navigation: {
                nextEl: '.collection-slide .swiper-button-next',
                prevEl: '.collection-slide .swiper-button-prev',
            },
            scrollbar: {
                el: '.collection-slide .swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                1280: {
                    slidesPerView:4,
                    spaceBetween: 22,           
                    slidesOffsetAfter:0,
                },
                990: {
                    slidesPerView:3,
                    spaceBetween: 20,           
                    slidesOffsetAfter:20,
                },
                750: {
                    slidesPerView:2.5,
                    spaceBetween: 20,           
                    slidesOffsetAfter:20,
                },
                0:{
                    slidesPerView:1.7,
                    spaceBetween: 20,                
                    slidesOffsetAfter:20,
                }
            },
            observer: true,   
            observeParents: true,
        });

        
    function setEqualHeight() {
        var maxHeight = 0;
        var maxTitleHeight = 0;
        $('.card_info_top').css('height', 'auto');
        
        $('.card_info_top').each(function() {
            var thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });
        //$('.card__heading').css('height', maxTitleHeight*0.5 + 'px');
        $('.card_info_top').css('height', (maxHeight) + 'px');
    }

    $(document).ready(function() {
        setEqualHeight();
        setInterval(function(){
            
            setEqualHeight();

        },1000)
    });

    $(window).on('resize', function() {
        setEqualHeight();
    });

        $('.collection-slide-tab-title li').click(function(){
            $('.collection-slide-tab-title li').removeClass('active');
            $(this).addClass('active');

            const collectionIdx = $(this).index()+1;
            $('.collection-slide-tab-content slider-component').hide();
            $('.collection-slide-tab-content slider-component:nth-of-type('+collectionIdx+')').show();

        })
    });
})(jQuery);